import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';

/**
 * URLクエリパラメータとattractiveConditionの状態を同期するカスタムフック
 * @param initialValue SSRで取得した初期値（string[]）
 * @returns [値, setter]
 */
export const useSyncAttractiveConditionWithQuery = (
  initialValue: string[] = [],
): [string[], (newValues: string[]) => void] => {
  const router = useRouter();
  const [value, setValue] = useState<string[]>(initialValue);

  // クエリがreadyになったら反映
  useEffect(() => {
    if (!router.isReady) return;
    const queryValue = router.query.wac;
    if (queryValue) {
      setValue(Array.isArray(queryValue) ? queryValue : [queryValue]);
    } else {
      setValue([]);
    }
  }, [router.isReady, router.query.wac]);

  // setter: URLクエリを更新
  const updateValue = (newValues: string[]) => {
    const nextQuery = Object.fromEntries(
      Object.entries({
        ...router.query,
        wac: newValues.length > 0 ? newValues : undefined,
      }).filter(([_, v]) => v !== undefined),
    );
    router.replace(
      {
        pathname: router.pathname,
        query: nextQuery,
      },
      undefined,
      {shallow: true},
    );
    setValue(newValues);
  };

  return [value, updateValue];
};
